<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M16.5 6.00001C16.5 5.68403 16.302 5.40195 16.0048 5.29461C15.7076 5.18727 15.375 5.2777 15.1731 5.52075C14.5093 6.31977 13.682 6.93995 12.536 7.2812C12.139 7.3994 11.913 7.81705 12.0312 8.21404C12.1494 8.61103 12.567 8.83703 12.964 8.71882C13.7483 8.48528 14.4191 8.14574 15 7.72796V14C15 14.4142 15.3358 14.75 15.75 14.75C16.1642 14.75 16.5 14.4142 16.5 14V6.00001Z"
            fill="#8E8E93"
        />
        <path
            d="M3.5 6.00001C3.5 5.58579 3.16421 5.25001 2.75 5.25001C2.33579 5.25001 2 5.58579 2 6.00001V14C2 14.4142 2.33579 14.75 2.75 14.75C3.16421 14.75 3.5 14.4142 3.5 14V10.75H8V14C8 14.4142 8.33579 14.75 8.75 14.75C9.16421 14.75 9.5 14.4142 9.5 14V6.00001C9.5 5.58579 9.16421 5.25001 8.75 5.25001C8.33579 5.25001 8 5.58579 8 6.00001V9.25001H3.5V6.00001Z"
            fill="#8E8E93"
        />
    </svg>
</template>
